<template>
  <div :id="'form-step-'+index" class="form-step" :class="step.invalid ? 'step invalid' : ''">
    <div data-webform-key="betekenisvol_werk" data-drupal-selector="edit-betekenisvol-werk" id="edit-betekenisvol-werk"
         class="js-form-wrapper form-wrapper form-group">

      <fieldset v-if="!review" :id="safeName(step.title)"
                class="js-form-item js-form-type-webform-markup form-type-webform-markup js-form-item-title-main-betekenis form-item-title-main-betekenis form-no-label form-group">
        <div class="d-fex justify-content-end">
          <h2 class="mb-2">{{step.title}}</h2>
        </div>
      </fieldset>

      <template v-if="review">
        <div class="row">
          <div class="col-md-12">
            <nav style="border-bottom:1px solid #5f5f5f;" v-if="review" class="tabnav smalltabs tab-nav pb-3 mb-5 align-items-start justify-content-center flex-wrap">

              <template v-for="(subcat,ind,c) in step.order">
                <button
                  :class="(c === activeSubcategory ? 'active' : '')"
                  @click.stop.prevent="loadSubcategory(c,subcat)"
                  class=" btn-link btn tab-link">
                  {{subcat.title}}
                </button>
              </template>
            </nav>
          </div>
          <div class="col-md-8">
<!--            <pre class="text-white">-->
<!--              {{subcatlabels}}-->
<!--              {{subcatScores}}-->
<!--            </pre>-->
            <generic-chart
              style="height: 400px"
              :maintain-ratio="true"
              v-if="subcatlabels.length && subcatScores.length"
              :name="step.title"
              :type="subcatlabels.length > 2 ? 'radar' : 'bar'"
              :set-labels="['Current','Previous']"
              :chart-labels="subcatlabels"
              :chart-data="[subcatScores,subcatScoresPrev]">
            </generic-chart>
          </div>
          <div class="col-md-4">

            <template class="" v-for="(subcategory,i,c) in step.order">
              <question-list v-show="c===activeSubcategory"
                             :ref="'subcategory-'+i"
                             :stepind="index"
                             :review="review"
                             :list="subcategory"></question-list>
            </template>

          </div>
        </div>
      </template>
      <template v-else>
        <template v-for="(list,i) in step.order">
          <question-list :ref="'subcategory-'+i"  :stepind="index" :review="review" :list="list"></question-list>
        </template>
      </template>
    </div>
<!--    <button @click.prevent="getSubcategoryScores">get subcat scores</button>-->
  </div>
</template>

<script>

  import QuestionList from "./QuestionList";
  import store from "../../store/store";
  import GenericChart from "../Charts/GenericChart";

  export default {
    created() {
      this.getSubcategoryScores();
    },
    mounted() {
      // console.log('mounted', this)
      this.getSubcategoryScores();
    },
    watch: {
      submittedAnswers() {
        // console.log('submitted changed')
        this.getSubcategoryScores();
      },
      previousAnswers(oldVal, newVal) {
        this.getSubcategoryScores();
      },
    },
    methods: {
      loadSubcategory(i, subcat) {
        this.activeSubcategory = i;
      },
      getSubcategoryScores() {
        // console.log('getting subcategory scores');
        this.subcatScores = [];
        this.subcatScoresPrev = [];
        this.subcatlabels = [];
        for (let key in this.step.order) {
          this.subcatlabels.push(this.step.order[key].title);
          let average = this.getSubcategoryAverage(this.step.order[key], 'submitted');
          let averagePrev = this.getSubcategoryAverage(this.step.order[key], 'previous');
          this.subcatScores.push(average)
          this.subcatScoresPrev.push(averagePrev)
        }
      },
      getSubcategoryAverage(subcategory, type = 'submitted') {
        // console.log('subcategory', subcategory.question)
        let answers = null;
        if(type === 'submitted'){
           answers = {...this.submittedAnswers};
        }else{
           answers = {...this.previousAnswers};
        }

        // console.log('answers', answers)
        if (!answers) {
          return 'no answers'
        }
        const subcat_scores = [];
        let sum = 0;
        subcategory.question.forEach(question => {
          const answer = answers[question.id];
          // console.log('question',question)
          // console.log('answer',answer)

          if (typeof answer !== 'undefined') {
            subcat_scores.push(answer.score)
          }
          else {
            // console.log('valuenotset');
          }
        });
        if (subcat_scores.length) {
          sum = subcat_scores.reduce((acc, val) => {
            return acc + val
          });

          let average = sum / subcat_scores.length;
          return this.truncate(average, 2)
        }

      }
    },
    props: {
      submittedAnswers: {type: Object},
      previousAnswers: {type: Object},
      index: {
        type: Number,
        default() {
          return 0;
        }
      },
      step: {
        type: Object,
        default() {
          return {
            Title: '',
            questions: [{subcategory: 1}]
          }
        }
      },
      review: {
        Boolean,
        default() {
          return false
        }
      }
    },
    data() {
      return {
        subcatScores: [],
        subcatScoresPrev: [],
        subcatlabels: [],
        activeSubcategory: 0,
      }
    },
    components: {
      GenericChart,
      QuestionList
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/Vitamins/Step.vue